import { Box, Divider, Typography, Grid, Paper } from '@mui/material';

export default function WirelessCoverageInfo({ wirelessCoverageInfo }) {
  return (
    <Grid container spacing={2}>
      <Paper elevation={0} sx={{ p: 3, width: 400 }}>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}>
            <Typography variant="subtitle1" sx={{ color: '#1C1C1E', fontWeight: 600, fontSize: '13px', mb: 0.5 }}>
              Status
            </Typography>
            {wirelessCoverageInfo?.status === '-' && <Typography sx={{ fontWeight: 600, fontSize: '35px', lineHeight: 1.2 }}>-</Typography>}
            {wirelessCoverageInfo?.status === 'Good' && <Typography sx={{ color: '#2e7d32', fontWeight: 600, fontSize: '35px', lineHeight: 1.2 }}>Good</Typography>}
            {wirelessCoverageInfo?.status === 'Warning' && (
              <Typography sx={{ color: '#FF9800', fontWeight: 600, fontSize: '35px', lineHeight: 1.2, letterSpacing: '-1.5px' }}>Warning</Typography>
            )}
            {wirelessCoverageInfo?.status === 'Critical' && <Typography sx={{ color: '#F44336', fontWeight: 600, fontSize: '35px', lineHeight: 1.2 }}>Critical</Typography>}
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1" sx={{ color: '#1C1C1E', fontWeight: 600, fontSize: '13px', mb: 0.5 }}>
              Total Connections
            </Typography>
            <Typography sx={{ color: '#172664', fontWeight: 600, fontSize: '35px', lineHeight: 1.2 }}>{wirelessCoverageInfo?.totalClient}</Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
            <Typography sx={{ color: '#1C1C1E', fontWeight: 600, fontSize: '13px', mb: 0.5, marginRight: 0.5 }}>Mean RSSI:</Typography>
            <Typography sx={{ color: '#4B68CF', fontWeight: 600, fontSize: '13px', lineHeight: '20px' }}>{wirelessCoverageInfo?.meanRSSI}</Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
            <Typography sx={{ color: '#1C1C1E', fontWeight: 600, fontSize: '13px', mb: 0.5, marginRight: 0.5 }}>
              {wirelessCoverageInfo?.threshold ? `Weak (<${wirelessCoverageInfo.threshold}):` : 'Weak:'}
            </Typography>
            <Typography sx={{ color: '#4B68CF', fontWeight: 600, fontSize: '13px', lineHeight: '20px' }}>{wirelessCoverageInfo?.weakPercent}</Typography>
          </Box>

          {/* <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
            <Typography sx={{ color: '#1C1C1E', fontWeight: 600, fontSize: '13px', mb: 0.5, marginRight: 0.5 }}>Threshold:</Typography>
            <Typography sx={{ color: '#4B68CF', fontWeight: 600, fontSize: '13px', lineHeight: '20px' }}>{wirelessCoverageInfo?.threshold}</Typography>
          </Box> */}
        </Box>
      </Paper>
    </Grid>
  );
}
